import { Data } from "../../../../../_ovlclient/src/dataapi"
import { PermissionHas } from "../../../../../_ovlclient/src/global/globalapi"
import {
  HookAppFileOpen_Type,
  HookAppUrlResolver_Type,
  HookFormValidatorsDefaults_Type,
} from "../../../../../_ovlclient/src/global/hooks"
import {
  HookAppRouting_Type,
  SYSAction,
  SYSScreen,
} from "../../../../../_ovlclient/src/index"
import {
  ScreenNavigateTo,
  ScreenCurrent,
} from "../../../../../_ovlclient/src/library/screenapi"
import { GENBPFilter_Init } from "../components/bpfilter/compdef"
import { GENImagePopup_Init } from "../components/imagepopup/compdef"
import { DATDocuments_Init } from "../features/datdocuments/compdef"
import { QUTOffering_Init } from "../features/qutoffering/compdef"
import { SPCSymbolPC_Init } from "../features/spcsymbolpc/compdef"
import { SYSAudit_Init } from "../../../../../_ovlclient/ovlsyscomponents/sysaudit01/compdef"
import { SYSEditorAsset_Init } from "../../../../../_ovlclient/ovlsyscomponents/syseditors/sysassetconfig01/compdef"
import { SYSLogin_Init } from "../../../../../_ovlclient/ovlsyscomponents/syslogin01/compdef"

import { LoginStart } from "../../../../../_ovlclient/ovlsyscomponents/syslogin01/features/sysloginapi"
import { SYSShellbar_Init } from "../../../../../_ovlclient/ovlsyscomponents/sysshellbar01/compdef"
import { SYSTranslation_Init } from "../../../../../_ovlclient/ovlsyscomponents/systranslation01/compdef"
import { SYSUserAdministration_Init } from "../../../../../_ovlclient/ovlsyscomponents/sysuseradministration01/compdef"
import { SYSUserSettingsPassword_Init } from "../../../../../_ovlclient/ovlsyscomponents/sysusersettings01/password/compdef"
import { PKGPackaging_Init } from "../screens/pkgpackaging/compdef"
import { GENDashboard_Init } from "../screens/gen/dashboard/compdef"
import { GENSettings_Init } from "../screens/gen/settings/compdef"
import { KPIAll_Init } from "../screens/kpi/allkpis/compdef"
import { SYSTOTP } from "../../../../../_ovlclient/ovlsyscomponents/systotp01/features/allactions"
import { SYSTOTP_Init } from "../../../../../_ovlclient/ovlsyscomponents/systotp01/compdef"
import { KPI_Init } from "../features/kpi/compdef"

const HookAppInit: SYSAction = async (_) => {
  SYSLogin_Init()
  SYSTOTP_Init()
  SYSShellbar_Init()

  // actions.ovl.internal.SetLanguage("DE")
  // return
}

const HookAppReady: SYSAction = async (_, { global }) => {
  //await globalThis.OvlRehydrateUserState("1")
  await LoginStart()
}

const HookHandleAdditionalLanguageResult: SYSAction<any> = async (
  value,
  { global }
) => {
  let state = global.getState()
  state.app.global.GEN.pics = {
    salesContact: value.salesPic,
  }
  if (!state.app.global.DAT.partner) {
    //@ts-ignore
    state.app.global.DAT.partner = {}
  }

  state.app.global.DAT.partner.salesContact = value.sales
}

const HookAppFileOpen: SYSAction<HookAppFileOpen_Type> = async (value) => {
  let anchor = document.createElement("a")
  anchor.href = window.URL.createObjectURL(value.blob)
  anchor.target = "_blank"
  // currently my prefered approach in all browsers...(without setting download it will directly open up and eventually gives a popup error and an uuid as the filename)
  anchor.download = value.fileName
  document.body.appendChild(anchor)
  anchor.click()
  setTimeout(() => {
    document.body.removeChild(anchor)
  }, 3000)
}

const HookAppUrlResolver: SYSAction<HookAppUrlResolver_Type> = (value) => {
  let currentUrl = window.location.hostname
  let currentPort = window.location.port
  if (currentUrl.indexOf("test") > -1 || currentUrl.indexOf("itflies") > -1) {
    value.isDemoToSet = true
  }
  if (currentUrl.indexOf("itfprtdev") > -1) {
    value.isDemoToSet = true
    value.apiUrlToSet = `http://${currentUrl}:1233/api/`
  } else {
    value.apiUrlToSet = `https://${currentUrl}${
      currentPort ? `:${currentPort}` : ""
    }/api/`
  }
}

const HookAppStateReady: SYSAction = async (_, { global }) => {
  SYSEditorAsset_Init()
  GENBPFilter_Init()
  if (PermissionHas("SYSAU")) {
    SYSAudit_Init()
  }
  if (PermissionHas("SYSTR")) {
    SYSTranslation_Init()
  }
  //SYSPortalSettings_Init()
  //SYSUserSettingsPassword_Init()
  if (
    PermissionHas("SYSUA") ||
    PermissionHas("SYSCA") ||
    PermissionHas("SYSUR") ||
    PermissionHas("SYSRA")
  ) {
    SYSUserAdministration_Init()
  }
  KPI_Init()
  GENDashboard_Init()
  GENSettings_Init()
  DATDocuments_Init()
  QUTOffering_Init()
  GENImagePopup_Init()
  PKGPackaging_Init()
  SPCSymbolPC_Init()
  KPIAll_Init() // Initialize AllKpis screen
}

const HookAppRouting: SYSAction<HookAppRouting_Type> = async (
  value,
  { global }
) => {
  let urlParams = value.urlParams
  let state = global.getState()
  let screen: SYSScreen = <SYSScreen>urlParams.get("s")
  let orderNum = urlParams.get("o")

  if (orderNum) {
    state.app.screens.DATOrder.orderDetailFormState.selectedOrder = orderNum
  }
  state.app.screens.DATOrder.orderDetailFormState.selectedOrder
  if (screen) {
    await ScreenNavigateTo(screen)
  }
}

const HookFormValidatorsDefaults: SYSAction<
  HookFormValidatorsDefaults_Type
> = async (value, { global }) => {
  if (value.formState.tableDefId === "QUTOfferingPos") {
    value.defaultsToSet.displayType = "OnlyOutline"
    value.defaultsToSet.summaryGroup = "ValidationKey"
    value.defaultsToSet.summaryDisplayType = "WhenTouched"
  }
}

export let hooks = {
  HookAppReady,
  HookAppStateReady,
  HookAppInit,
  HookAppFileOpen,
  HookAppUrlResolver,
  HookAppRouting,
  HookHandleAdditionalLanguageResult,
  HookFormValidatorsDefaults,
}
